import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlueConfigurationService } from './glue-configuration.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IFeatureProducts } from '../models/featured-products.models';

@Injectable({
  providedIn: 'root',
})
export class FeaturedProductsService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);

  private readonly featuredProductsEndpoint: string = '/content-product-abstract-lists/';
  private readonly contentProducts: string = '/content-product-abstract';
  private readonly glueUrl: string = this.glueConfiguration.getEndpointUrl();

  private readonly httpParamsForFeatureProductItems: { params: HttpParams } = {
    params: new HttpParams()
      .set('include', 'abstract-product-image-sets,abstract-product-prices,product-labels'),
  };

  private static handleError(err: any): Observable<any> {
    return throwError(
      err.error instanceof ErrorEvent ? `An error occurred: ${err.error.message}` : err.status,
    );
  }

  getFeaturedProducts(featureProductsKey: any): Observable<IFeatureProducts> {
    const url: string = this.glueUrl + this.featuredProductsEndpoint + featureProductsKey + this.contentProducts;
    return this.httpClient.get<IFeatureProducts>(url, this.httpParamsForFeatureProductItems)
      .pipe(
        catchError(error => FeaturedProductsService.handleError(error)),
      );
  }
}
